import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { buildLotteryRewardTagSize } from '../service/lotteryService'


export default /*#__PURE__*/_defineComponent({
  __name: 'LotteryRewardImage',
  props: {
    image: null,
    icon: null,
    alt: { default: '' },
    size: { default: 66 }
  },
  setup(__props: any) {

const props = __props as { image: string, icon?: string, alt: string, size: number };



const tagSize = computed(() => buildLotteryRewardTagSize(props.size))

const rootStyle = computed(() => ({
  width: `${props.size / 12}rem`,
  height: `${props.size / 12}rem`,
  '--tag-width': `${tagSize.value.width / 12}rem`,
  '--tag-height': `${tagSize.value.height / 12}rem`,
}))

return { __sfc: true,props, tagSize, rootStyle }
}

})